import { Component, HostListener} from "@angular/core";
import { RefreshTokenService } from "../app/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"]
})
export class AppComponent {
  constructor(private refreshTokenService: RefreshTokenService) {}
  // constructor() {}

  @HostListener("window:unload", [])
  unloadHandler() {
    // Invalidate current tab as active RefreshToken timer
    this.refreshTokenService.invalidateCurrentTabId();
  }

  @HostListener("window:beforeunload", [])
  beforeUnloadHander() {
    // ...
  }
}
